import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
    justifyContent: 'space-between !important',
    margin: '0 !important',
    padding: '0 0 2rem 0 !important',
    width: '100% !important',
    height: '28rem !important',

    '&.tier3': {
      height: '33rem !important',
    },
  },
  mapPlaceholder: {
    height: '20rem !important',
  },
  cityList: {
    display: 'flex !important',
    alignItems: 'center !important',
  },
  map: {
    display: 'flex !important',
    alignItems: 'center',
    padding: '0 !important',
  },
  renderMap: {
    padding: '0 !important',
    width: '100%',
  },
  noPadding: {
    padding: '0 !important',
  },
  noMargin: {
    margin: '0 !important',
  },
  formSelect: {
    marginLeft: '1.5rem !important',
  },
  topMetros: {
    marginTop: '1rem !important',
  },
  download: {
    background: '#fff',
    padding: '1.425rem 1rem',
  },
  header: {
    color: `${theme.darkGray} !important`,
  },
  noDataMapRow: {
    display: 'flex !important',
    justifyContent: 'center !important',
    padding: '0 !important',
    width: '100%',
    height: '100%',
  },
});

export default styles;
